module.exports = __webpack_public_path__ + "media/en_gb_s3_Hailey.c51dc00f.oga";